import React from "react";
import {CCol, CFormInput, CFormLabel, CFormText, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import {applyFilter} from "../../store/slice/component/table";
import DatePicker from 'react-date-picker';

const MemoRejectedSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    let getDate = () => {
        if (data.rejected_at) {
            return new Date(data.rejected_at);
        }
        return '';
    };
    return <>
        <CRow className={'mt-1'}>
            <CCol sm={12} md={6}>
                <CFormLabel>Rejected By</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'rejected_by_name',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.rejected_by_name || ''}
                />
                <CFormText>Example: Suresh Nai, Mahesh Mistry</CFormText>
            </CCol>
            <CCol sm={12} md={6}>
                <CFormLabel>Rejected Time Stamp</CFormLabel>
                <DatePicker
                    onChange={(e) => {
                        dispatch(applyFilter({
                            field_name: 'rejected_at',
                            value: e,
                        }));
                    }}
                    value={getDate() || ''}
                    className={'form-control'}
                />
            </CCol>
        </CRow>
    </>;
}

export default MemoRejectedSearch;
